export default [
    {
        id: "e889d739-ae26-481c-95cc-df8124fc76bf",
        title: "Mozart Mobile",
        slug: "mozart-2",
        type: "Ad. Film",
        role: "DOP | Editor | Producer",
        details: [
            {
                type: "VIDEO",
                videoId: "DQSgL4EOEfs",
            },
            // {
            //     type: "IMAGES",
            //     images: ["image-name", "sss"],
            // },
        ],
    },
    {
        id: "663ebc0e-ac7a-46b1-a49d-f07d8e471203",
        title: "Stay",
        slug: "stay",
        type: "Short Film",
        role: "DOP",
        details: [
            {
                type: "VIDEO",
                videoId: "mfjcyo_uggM",
            },
        ],
    },
    {
        id: "cfa3e497-e755-4076-a4c4-3f87187250a3",
        title: "Ikko Dil",
        slug: "ikko-dil",
        type: "Music Video",
        role: "1st AC",
        details: [
            {
                type: "VIDEO",
                videoId: "zG_6IhZEO1M",
            },
        ],
    },
    {
        id: "d0eb5d0a-c6f1-4655-96ea-07d92177263c",
        title: "The Room",
        slug: "the-room",
        type: "Short Film",
        role: "DOP",
        details: [
            {
                type: "VIDEO",
                videoId: "HgRU-E9HuUs",
            },
        ],
    },
    {
        id: "d0eb5d0a-c6f1-4655-96ea-07d92177263c",
        title: "Tempering",
        slug: "tempering",
        type: "Short Film",
        role: "DOP",
        details: [
            {
                type: "VIDEO",
                videoId: "bBJpRZhrfoo",
            },
        ],
    },
    {
        id: "421ce365-ad3a-4d2a-bdbe-bbb65d3d97ba",
        title: "Noor I",
        slug: "noor-a-fashion-campaign-one",
        type: "Ad. Campaign",
        role: "DOP | Editor",
        details: [
            {
                type: "VIDEO",
                videoId: "aCb5V0NZBaI",
            },
            // {
            //     type: "IMAGES",
            //     images: ["image-name", "sss"],
            // },
        ],
    },
    {
        id: "b9501142-03cd-4adb-987b-820227d27ea1",
        title: "AI Hack",
        slug: "ai-hack",
        type: "Hackathon Film",
        role: "DOP | Editor",
        details: [
            {
                type: "VIDEO",
                videoId: "J-satEynTvc",
            },
            // {
            //     type: "IMAGES",
            //     images: ["image-name", "sss"],
            // },
        ],
    },
    {
        id: "762f219a-df71-424f-99ca-02b842f9d62b",
        title: "Can I Just Say Something",
        slug: "cijss",
        type: "Short Film",
        role: "Gaffer",
        details: [
            {
                type: "VIDEO",
                videoId: "t80rkcmYVNg",
            },
            // {
            //     type: "IMAGES",
            //     images: ["image-name", "sss"],
            // },
        ],
    },
    {
        id: "1e3f9709-11c7-47e1-893f-798296bb6b07",
        title: "Alif",
        slug: "alif",
        type: "Portrait Film",
        role: "DOP | Editor",
        details: [
            {
                type: "VIDEO",
                videoId: "bHUGAE7BT9E",
            },
        ],
    },
    {
        id: "2e3c8681-64ce-49b8-b0a3-adab5d66bb5e",
        title: "Well Played",
        slug: "well-played",
        type: "Book Trailer",
        role: "DOP | Editor",
        details: [
            {
                type: "VIDEO",
                videoId: "71vcVpXvFzE",
            },
        ],
    },
    {
        id: "3e17e770-c383-4ece-b5f6-83b81dab5b51",
        title: "Mozart AI 0.5",
        slug: "mozart-1",
        type: "Ad Film",
        role: "Director | DOP | Editor",
        details: [
            {
                type: "VIDEO",
                videoId: "sQdj2qvAWFk",
            },
        ],
    },     {
        id: "ec3391c7-4138-4a79-b6b3-438f5924d3dc",
        title: "Seasons - Mychelle",
        slug: "seasons",
        type: "Music Video",
        role: "Grip Trainee",
        details: [
            {
                type: "VIDEO",
                videoId: "5ESdkAMnBzI",
            },
        ],
    },    
    {
        id: "50b74047-d68c-4c18-b68c-311cb1573bb6",
        title: "Celestial",
        slug: "celestial",
        type: "Event Highlights",
        role: "DOP | Editor",
        details: [
            {
                type: "VIDEO",
                videoId: "g1arQ_F-n80",
            },
        ],
    },
    {
        id: "544e889e-1820-403e-840b-4f567e172750",
        title: "Bindu",
        slug: "bindu",
        type: "Short Film",
        role: "Assistant Director",
        details: [
            {
                type: "VIDEO",
                videoId: "9SNHbp_uJ2k",
            },
        ],
    },
    {
        id: "58a2d994-c798-4902-891b-b22169e83dc3",
        title: "Bittu",
        slug: "bittu",
        type: "Short Film",
        role: "Production Manager",
        details: [
            {
                type: "VIDEO",
                videoId: "j0bGpJZJDZ8",
            },
        ],
    },
    {
        id: "682a6a28-4ddf-4e63-804f-1314709e2354",
        title: "Women of 2035",
        slug: "women-of-2035",
        type: "Campaign Film",
        role: "II DOP",
        details: [
            {
                type: "VIDEO",
                videoId: "AMsQM1wXAMk",
            },
        ],
    },
    {
        id: "3d8394ae-1c4a-4336-bebf-93cafd363b91",
        title: "The Legend of Jungle",
        slug: "the-legend-of-jungle",
        type: "Event Highlights",
        role: "DOP",
        details: [
            {
                type: "VIDEO",
                videoId: "Cwmus-2CfZA",
            },
        ],
    },
    {
        id: "54c06573-378f-4c02-a7bb-aef67011fdbf",
        title: "WCMT x ISOBAR",
        slug: "wcmt-x-isobar",
        type: "Concert Highlights",
        role: "DOP | Editor",
        details: [
            {
                type: "VIDEO",
                videoId: "1t7VMGUZuxg",
            },
        ],
    },
    {
        id: "0f6280b0-240d-4b35-8d81-2e29585becf7",
        title: "Noor II",
        slug: "noor-a-fashion-campaign-two",
        type: "Ad. Campaign",
        role: "DOP | Editor",
        details: [
            {
                type: "VIDEO",
                videoId: "cFA6Gx3n-hU",
            },
        ],
    },
    {
        id: "d8a6b57c-cd11-435f-887d-cbab6bab8219",
        title: "Breaking Bride",
        slug: "breaking-bride",
        type: "Short Film",
        role: "DOP",
        details: [
            {
                type: "VIDEO",
                videoId: "c9PlEhF1ZpM",
            },
        ],
    },
    {
        id: "5e30c2a5-99b6-4a75-9836-6ae6df66dbe0",
        title: "Dream Girl",
        slug: "dream-girl",
        type: "Short Film",
        role: "II DOP",
        details: [
            {
                type: "VIDEO",
                videoId: "FXhd5z9MsfU",
            },
        ],
    },
    {
        id: "41f58500-eee6-4aa6-a04d-3b0a3881b873",
        title: "Phadphadlal",
        slug: "phadphadlal",
        type: "Ad. Film",
        role: "DOP",
        details: [
            {
                type: "VIDEO",
                videoId: "AVsH5UOvisA",
            },
        ],
    },
    {
        id: "26030513-1860-466e-a0be-df039f75b194",
        title: "Mukhtalif",
        slug: "mukhtalif",
        type: "Ad. Film",
        role: "DOP | Editor",
        details: [
            {
                type: "VIDEO",
                videoId: "DwdyFww2GbU",
            },
        ],
    },
    {
        id: "a99cf7db-3566-46d6-859d-85df35418128",
        title: "MYNTRA x H&M | MOCK AD.",
        slug: "myntra-x-handm-mock-ad",
        type: "Mock Ad.",
        role: "Assistant Cinematographer",
        details: [
            {
                type: "VIDEO",
                videoId: "856okn-P1Hg",
            },
        ],
    },
    {
        id: "03e7beaa-ee52-48e5-b76d-c999155f4004",
        title: "Shaam-e-Awadh",
        slug: "shaam-e-awadh",
        type: "Event Highlights",
        role: "DOP",
        details: [
            {
                type: "VIDEO",
                videoId: "MI0PqYu10jI",
            },
        ],
    },
    {
        id: "25809712-ff2d-437f-968c-8ffdffcf5f67",
        title: "Bubbles & Bowties",
        slug: "bubbles-and-bowties",
        type: "Event Highlights",
        role: "DOP",
        details: [
            {
                type: "VIDEO",
                videoId: "ao-XiHjzc3s",
            },
        ],
    },
    {
        id: "aa9739d7-6883-41b8-a811-9352260e23a7",
        title: "Nut Cracker",
        slug: "nut-cracker",
        type: "Event Highlights",
        role: "DOP",
        details: [
            {
                type: "VIDEO",
                videoId: "fp7SmYdqTQA",
            },
        ],
    },
    {
        id: "a5c6c1e3-a4c7-411e-a626-64f5c86324b9",
        title: "Sach Keh Raha Hai Cover",
        slug: "sach-keh-raha-hai-cover",
        type: "Music Video",
        role: "DOP",
        details: [
            {
                type: "VIDEO",
                videoId: "MTUzwE_HVSo",
            },
        ],
    },
    {
        id: "ee942925-64a4-4481-a8dd-667685e33884",
        title: "Showbuzz",
        slug: "showbuzz",
        type: "Event Highlights",
        role: "DOP",
        details: [
            {
                type: "VIDEO",
                videoId: "3r-bMF8YQ_M",
            },
        ],
    },
    {
        id: "418fea5a-46df-43a9-b559-d48f2c3cbc38",
        title: "Chowmein",
        slug: "chowmein",
        type: "Short Film",
        role: "DOP",
        details: [
            {
                type: "VIDEO",
                videoId: "dF_5rC9Lyu8",
            },
        ],
    },
    {
        id: "2c03fa84-fa16-4f1a-a704-9a4027193ce3",
        title: "Khushi - A Tribute To Mothers",
        slug: "khushi-a-tribute-to-mothers",
        type: "Short Film",
        role: "Sound Recordist",
        details: [
            {
                type: "VIDEO",
                videoId: "QQ0-5L8rMMI",
            },
        ],
    },
    {
        id: "4f8037f1-b434-459c-bd91-dbd4f4f0b908",
        title: "Nazare",
        slug: "nazare",
        type: "Music Video",
        role: "Assistantt Cinematographer",
        details: [
            {
                type: "VIDEO",
                videoId: "Zoj6p7cNmi8",
            },
        ],
    },
    {
        id: "48580cd2-9b52-4349-a3b6-380d2cadb0b9",
        title: "SIMONE GOMES Fashion Film",
        slug: "simone-gomes-fashion-film",
        type: "Fashion Film",
        role: "Camera Assistant",
        details: [
            {
                type: "VIDEO",
                videoId: "SYQ5HGA1OrQ",
            },
        ],
    },
    {
        id: "2eca8da1-5a92-466d-8b44-c635d95322e1",
        title: "CARLOTA COSTA Fashion Film",
        slug: "carlota-costa-fashion-film",
        type: "Fashion Film",
        role: "Camera Assistant",
        details: [
            {
                type: "VIDEO",
                videoId: "-N74rojaoyQ",
            },
        ],
    },
];
